"use client";

import { designClass } from "@/dev-testbed/ui/design.ts";

export type GesperrtOverlayProps = {
  open: boolean;
  prozessTitel: string;
  schrittTitel: string;
  schrittNummer: number;
  bereichLabel: string;
  onZurueck: () => void;
  onTrotzdem: () => void;
};

/**
 * Ruhiges Modal, wenn eine Route außerhalb des Testumfangs angeklickt wird.
 */
export function GesperrtOverlay({
  open,
  prozessTitel,
  schrittTitel,
  schrittNummer,
  bereichLabel,
  onZurueck,
  onTrotzdem,
}: GesperrtOverlayProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dev-test-gesperrt-title"
    >
      <div
        className={`${designClass.karte} w-full max-w-md border border-[var(--border-default)] bg-[var(--surface-app)] p-6 shadow-lg`}
      >
        <h2
          id="dev-test-gesperrt-title"
          className={`${designClass.ueberschrift2} text-[var(--text-primary)]`}
        >
          Das gehört nicht zum Test
        </h2>
        <p className={`${designClass.fliesstext} mt-3 text-[var(--text-secondary)]`}>
          Du testest gerade: {prozessTitel} · Schritt {schrittNummer} „{schrittTitel}"
        </p>
        <p className={`${designClass.fliesstext} mt-2 text-[var(--text-secondary)]`}>
          Der Bereich „{bereichLabel}" ist dabei nicht Teil des Tests.
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onZurueck}
            className={`${designClass.bedienelement} ${designClass.fliesstext} border border-[var(--border-default)] bg-[var(--surface-secondary)] px-3 py-2 text-[var(--text-primary)] hover:bg-[var(--surface-hover)]`}
          >
            Zurück zum Test
          </button>
          <button
            type="button"
            onClick={onTrotzdem}
            className={`${designClass.bedienelement} ${designClass.fliesstext} px-3 py-2 text-[var(--text-muted)] underline-offset-2 hover:text-[var(--text-secondary)] hover:underline`}
          >
            Trotzdem öffnen — beendet den Test
          </button>
        </div>
      </div>
    </div>
  );
}
